import { Outlet, Navigate, useParams } from 'react-router-dom';

import DepartmentLayout from '../../pages/layouts/department-layout';
import useAuth from '../../hooks/useAuth';
import { ApplicationRole } from '../../models/authentication/application-roles';
import { useEffect } from 'react';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { fetchSubDepartment } from '../../store/features/organisation/department-slice';

export const DepartmentRoute = () => {
    const { initialized, loading, authenticated, role } = useAuth();
    const { subDepartmentId } = useParams();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (subDepartmentId) {
            dispatch(fetchSubDepartment(Number(subDepartmentId)))
        }
    }, [subDepartmentId])

    if (!initialized || loading) {
        return <div>Loading...</div>;
    }

    if (!authenticated) {
        return <Navigate to="/login" replace />
    }

    if (role == ApplicationRole.SupplierManager) {
        return <Navigate to="/admin" replace />;
    }

    if (role === ApplicationRole.OrderApprover) {
        return <Navigate to="/admin/approvals" replace />;
    }


    return (
        <DepartmentLayout>
            <Outlet />
        </DepartmentLayout>
    )
};